import React from "react";
import { formatDateWithoutTime } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { months } from "../../utils/months";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate, useParams } from "react-router";
import { LocalConvenienceStoreOutlined } from "@mui/icons-material";

const GemBonus = ({ gemBonus }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleExpand = () => {
    navigate("/gem-bonus");
  };

  return (
    <div className="col-md-12">
      <div className="joinings_viewBox">
        <div className="joinings_viewBox_head">
          <h5>{t("GemBonus")} </h5>
          <p style={{ textAlign: "right" }}>
            {" "}
            <a className="btn btn-tree-act" onClick={handleExpand}>
              <i className="fa fa-expand"></i>
            </a>
          </p>
        </div>

        <div className="teammbrs_cnt">
          {!gemBonus ? (
            <div className="teammbrs_cnt_row">
              <div className="teammbrs_cnt_img">
                <Skeleton
                  width="45px"
                  height="45px"
                  circle
                  containerClassName="avatar-skeleton"
                  count={3}
                />
              </div>
              <div className="teammbrs_cnt_name_dtl">
                <div className="teammbrs_cnt_name">
                  <Skeleton count={6} />
                </div>
              </div>
            </div>
          ) : gemBonus?.length === 0 ? (
            <div className="no-data-div">
              <div className="no-data-div-image">
                <img src="/images/nodata-image.png" alt="No data" />
              </div>
              <p>{t("noDataFound")}</p>
            </div>
          ) : (
            <div className="row">
              {/* Active Status Section */}
              <div className="forver_content">
                {/* <span className="key">{t("Active Status")}</span>
                <span className="value">
                  <div
                    style={{
                      height: "15px",
                      width: "15px",
                      border: "1px solid",
                      float: "right",
                      backgroundColor: eagleData?.userActive
                        ? "green"
                        : "transparent",
                    }}
                  />
                </span> */}
              </div>
              <div className="forver_content">
                <span className="key">{t("Leadership bonus Qualified")}</span>
                <span className="value">
                  <div
                    style={{
                      height: "15px",
                      width: "15px",
                      border: "1px solid",
                      float: "right",
                      backgroundColor:
                        gemBonus?.isLeaderShipQulified > 0 ? "green" : "none",
                    }}
                  ></div>
                </span>
              </div>

              <table className="table">
                <thead>
                  <tr>
                    <td></td>
                    <td>{t("Level 1")}</td>
                    <td>{t("Level 2")}</td>
                    <td>{t("Level 3")}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>
                      <div>
                        {t("1st Gen Active Leaders")} ("{t("You Have")}:{" "}
                        {gemBonus?.firstGenerationActiveLeaders || 0})
                      </div>
                    </th>
                    {gemBonus?.configs?.map((config, index) => (
                      <td key={index}>
                        <ProgressBar
                          now={parseFloat(
                            gemBonus?.firstGenerationActiveLeaders ?? 0
                          )}
                          max={parseFloat(config.first_generation ?? 0)}
                          label={`${parseFloat(
                            gemBonus?.firstGenerationActiveLeaders ?? 0
                          )} / ${parseFloat(config.first_generation ?? 0)}`}
                          variant="success"
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {config.first_generation} {t("Required")}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th>
                      <div>
                        {t("25 KC Active Leaders Lines")} ({t("You Have")}:{" "}
                        {gemBonus?.activeLeaderLines || 0})
                      </div>
                    </th>
                    {gemBonus?.configs?.map((config, index) => (
                      <td key={index}>
                        <ProgressBar
                          now={parseFloat(gemBonus?.activeLeaderLines ?? 0)}
                          max={parseFloat(config.downline_manager_count ?? 0)}
                          label={`${parseFloat(
                            gemBonus?.activeLeaderLines ?? 0
                          )} / ${parseFloat(
                            config.downline_manager_count ?? 0
                          )}`}
                          variant="success"
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {config.downline_manager_count || 0} {t("Required")}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th>
                      <div>{t("EagleManagerLevel")}</div>
                    </th>
                    {gemBonus?.configs?.map((config, index) => (
                      <td key={index}>
                        {gemBonus?.eagleManagerLevel &&
                        gemBonus?.eagleManagerLevel.gem_config_id ==
                          config.id ? (
                          <i
                            className="fa fa-check-circle"
                            style={{ fontSize: "12px", color: "green" }}
                          ></i>
                        ) : (
                          <i
                            className="fa fa-times-circle"
                            style={{ fontSize: "12px", color: "red" }}
                          ></i>
                        )}
                        <p>{config.name || 0}</p>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GemBonus;
